"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Layout_1 = require("./components/Layout");
require("./custom.css");
exports.default = (function () { return (React.createElement(React.Fragment, null,
    React.createElement(Layout_1.default, null))); });
//# sourceMappingURL=App.js.map